<template>
  <div class="loader-container" :class="containerClass">
    <div v-for="x of 9" :key="x"></div>
  </div>
</template>
<script>
export default {
  name: 'CircleLoader',
  components: {},
  props: {
    containerClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">

.loader-container {
  --resize: 1;
  $animation-delay: 0.4s;

  display: inline-block;
  position: relative;
  width: calc(80px / var(--resize));
  height: calc(80px / var(--resize));

  & div {
    position: absolute;
    width: calc(12px / var(--resize));
    height: calc(12px / var(--resize));
    background: #fff;
    border-radius: 50%;
    animation: loading-dots 3.2s linear infinite;

    @keyframes loading-dots {
      0%,
      100% {
        opacity: 0;
        transform: scale(1);
      }
      20% {
        opacity: 0.4;
        transform: scale(1.15);
      }
      30% {
        opacity: 0.6;
        transform: scale(1.25);
      }
      40% {
        opacity: 0.8;
        transform: scale(1.35);
      }
      50% {
        opacity: 1;
        transform: scale(1.55);
      }
      60% {
        opacity: 0.6;
        transform: scale(1.35);
      }
      80% {
        opacity: 0.2;
        transform: scale(1.15);
      }
    }

    &:nth-child(1) {
      animation-delay: 0s - (2 * $animation-delay);
      top: calc(54px / var(--resize));
      left: calc(55px / var(--resize));
    }

    &:nth-child(2) {
      animation-delay: 0s - (3 * $animation-delay);
      top: calc(33px / var(--resize));
      left: calc(64px / var(--resize));
    }

    &:nth-child(3) {
      animation-delay: 0s - (4 * $animation-delay);
      top: calc(14px / var(--resize));
      left: calc(57px / var(--resize));
    }

    &:nth-child(4) {
      animation-delay: 0s - (5 * $animation-delay);
      top: calc(4px / var(--resize));
      left: calc(40px / var(--resize));
    }

    &:nth-child(5) {
      animation-delay: 0s - (6 * $animation-delay);
      top: calc(5px / var(--resize));
      left: calc(20px / var(--resize));
    }

    &:nth-child(6) {
      animation-delay: 0s - (7 * $animation-delay);
      top: calc(20px / var(--resize));
      left: calc(4px / var(--resize));
    }

    &:nth-child(7) {
      animation-delay: 0s - (8 * $animation-delay);
      top: calc(40px / var(--resize));
      left: calc(1px / var(--resize));
    }

    &:nth-child(8) {
      animation-delay: 0s;
      top: calc(56px / var(--resize));
      left: calc(14px / var(--resize));
    }

    &:nth-child(9) {
      animation-delay: 0s - (1 * $animation-delay);
      top: calc(62px / var(--resize));
      left: calc(34px / var(--resize));
    }
  }
}
</style>